import secureStorage from "../../plugins/secureStorage";

export default {
    status:     '',
    token:      secureStorage.getItem('token') || '',
    user:       secureStorage.getItem('user') || {},
    verified:   false,
}